import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgendaMedicaHorarioIndividualMaintenanceComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-horario-individual-maintenance/agenda-medica-horario-individual-maintenance.component';
import { AgendaMedicaListComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-list/agenda-medica-list.component';
import { AgendaMedicaMaintenanceComponent } from './com/copeagenda/view/agenda-medica/agenda-medica-maintenance/agenda-medica-maintenance.component';
import { AssociacaoFilialEspecialidadeComponent } from './com/copeagenda/view/associacoes/associacao-filial-especialidade/associacao-filial-especialidade.component';
import { AssociacaoFilialMedicoComponent } from './com/copeagenda/view/associacoes/associacao-filial-medico/associacao-filial-medico.component';
import { AssociacaoMedicoPlanoSaudeComponent } from './com/copeagenda/view/associacoes/associacao-medico-plano-saude/associacao-medico-plano-saude.component';
import { AssociacaoPlanoSaudeProcedimentoComponent } from './com/copeagenda/view/associacoes/associacao-plano-saude-procedimento/associacao-plano-saude-procedimento.component';
import { AtendimentoConsultaDetailComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/atendimento-consulta-detail/atendimento-consulta-detail.component';
import { AtendimentoConsultaListComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/atendimento-consulta-list/atendimento-consulta-list.component';
import { LocalizarAtendimentoConsultaListComponent } from './com/copeagenda/view/atendimento/atendimento-consulta/localizar-atendimento-consulta-list/localizar-atendimento-consulta-list.component';
import { AtendimentoProcedimentoDetailComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/atendimento-procedimento-detail/atendimento-procedimento-detail.component';
import { AtendimentoProcedimentoListComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/atendimento-procedimento-list/atendimento-procedimento-list.component';
import { LocalizarAtendimentoProcedimentoListComponent } from './com/copeagenda/view/atendimento/atendimento-procedimento/localizar-atendimento-procedimento-list/localizar-atendimento-procedimento-list.component';
import { InformacaoCancelamentoCreateComponent } from './com/copeagenda/view/atendimento/informacao-cancelamento-create/informacao-cancelamento-create.component';
import { InformacaoCancelamentoDetailComponent } from './com/copeagenda/view/atendimento/informacao-cancelamento-detail/informacao-cancelamento-detail.component';
import { InformacaoFechamentoDetailComponent } from './com/copeagenda/view/atendimento/informacao-fechamento-detail/informacao-fechamento-detail.component';
import { TipoMarcacaoEnum } from './com/copeagenda/view/enums/tipo-marcacao-enum';
import { EspecialidadeListComponent } from './com/copeagenda/view/especialidade/especialidade-list/especialidade-list.component';
import { EspecialidadeMaintenanceComponent } from './com/copeagenda/view/especialidade/especialidade-maintenance/especialidade-maintenance.component';
import { FaltaMedicaListComponent } from './com/copeagenda/view/falta-medica/falta-medica-list/falta-medica-list.component';
import { FaltaMedicaMaintenanceComponent } from './com/copeagenda/view/falta-medica/falta-medica-maintenance/falta-medica-maintenance.component';
import { FeriadoListComponent } from './com/copeagenda/view/feriado/feriado-list/feriado-list.component';
import { FeriadoMaintenanceComponent } from './com/copeagenda/view/feriado/feriado-maintenance/feriado-maintenance.component';
import { FilialListComponent } from './com/copeagenda/view/filial/filial-list/filial-list.component';
import { FilialMaintenanceComponent } from './com/copeagenda/view/filial/filial-maintenance/filial-maintenance.component';
import { HistoricoEventoListComponent } from './com/copeagenda/view/historico-evento/historico-evento-list/historico-evento-list.component';
import { AuthGuard } from './com/copeagenda/view/interceptors/auth.guard';
import { LoginComponent } from './com/copeagenda/view/login/login.component';
import { AgendamentoPacienteListComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/agendamento-paciente-list/agendamento-paciente-list.component';
import { CadastroDependenteComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/cadastro-dependente/cadastro-dependente.component';
import { CadastroPacienteComponent } from './com/copeagenda/view/marcacao/cadastro-paciente/cadastro-paciente.component';
import { EnviarComprovanteEmailComponent } from './com/copeagenda/view/marcacao/enviar-comprovante-email/enviar-comprovante-email.component';
import { EnviarComprovanteSmsComponent } from './com/copeagenda/view/marcacao/enviar-comprovante-sms/enviar-comprovante-sms.component';
import { MarcacaoConsultaRealizadaComponent } from './com/copeagenda/view/marcacao/marcacao-consulta-realizada/marcacao-consulta-realizada.component';
import { MarcacaoConsultaComponent } from './com/copeagenda/view/marcacao/marcacao-consulta/marcacao-consulta.component';
import { MarcacaoProcedimentoRealizadoComponent } from './com/copeagenda/view/marcacao/marcacao-procedimento-realizado/marcacao-procedimento-realizado.component';
import { SelecaoConsultaComponent } from './com/copeagenda/view/marcacao/selecao-consulta/selecao-consulta.component';
import { SelecaoPacienteComponent } from './com/copeagenda/view/marcacao/selecao-paciente/selecao-paciente.component';
import { SelecaoProcedimentoComponent } from './com/copeagenda/view/marcacao/selecao-procedimento/selecao-procedimento.component';
import { MedicoListComponent } from './com/copeagenda/view/medico/medico-list/medico-list.component';
import { MedicoMaintenanceComponent } from './com/copeagenda/view/medico/medico-maintenance/medico-maintenance.component';
import { MotivoCancelamentoListComponent } from './com/copeagenda/view/motivo-cancelamento/motivo-cancelamento-list/motivo-cancelamento-list.component';
import { MotivoCancelamentoMaintenanceComponent } from './com/copeagenda/view/motivo-cancelamento/motivo-cancelamento-maintenance/motivo-cancelamento-maintenance.component';
import { EnvioComprovanteListComponent } from './com/copeagenda/view/notificacoes/envio-comprovante/envio-comprovante-list/envio-comprovante-list.component';
import { NotificacaoCancelamentoCreateComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-create/notificacao-cancelamento-create.component';
import { NotificacaoCancelamentoDetailComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-detail/notificacao-cancelamento-detail.component';
import { NotificacaoCancelamentoListComponent } from './com/copeagenda/view/notificacoes/notificacao-cancelamento/notificacao-cancelamento-list/notificacao-cancelamento-list.component';
import { ProcurarPacienteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/procurar-paciente/procurar-paciente.component';
import { SelecionarMarcacaoConsultaParaReenvioComprovanteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/selecionar-marcacao-consulta-para-reenvio-comprovante/selecionar-marcacao-consulta-para-reenvio-comprovante.component';
import { SelecionarMarcacaoProcedimentoParaReenvioComprovanteComponent } from './com/copeagenda/view/notificacoes/reenvio-comprovante/selecionar-marcacao-procedimento-para-reenvio-comprovante/selecionar-marcacao-procedimento-para-reenvio-comprovante.component';
import { CadastroDependentePeloAdminComponent } from './com/copeagenda/view/paciente/dependente/cadastro-dependente-pelo-admin/cadastro-dependente-pelo-admin.component';
import { DependenteListComponent } from './com/copeagenda/view/paciente/dependente/dependente-list/dependente-list.component';
import { DependenteMaintenanceComponent } from './com/copeagenda/view/paciente/dependente/dependente-maintenance/dependente-maintenance.component';
import { TransferenciaTitularMaintenanceComponent } from './com/copeagenda/view/paciente/dependente/transferencia-titular-maintenance/transferencia-titular-maintenance.component';
import { PacienteListComponent } from './com/copeagenda/view/paciente/paciente-list/paciente-list.component';
import { PacienteMaintenanceComponent } from './com/copeagenda/view/paciente/paciente-maintenance/paciente-maintenance.component';
import { PaginaInicialComponent } from './com/copeagenda/view/pagina-inicial/pagina-inicial.component';
import { RedefinirSenhaComponent } from './com/copeagenda/view/perfil/redefinir-senha/redefinir-senha.component';
import { PlanoSaudeListComponent } from './com/copeagenda/view/plano-saude/plano-saude-list/plano-saude-list.component';
import { PlanoSaudeMaintenanceComponent } from './com/copeagenda/view/plano-saude/plano-saude-maintenance/plano-saude-maintenance.component';
import { CadastroConflitoComponent } from './com/copeagenda/view/procedimento/conflito/cadastro-conflito/cadastro-conflito.component';
import { ProcedimentoAgendaListComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/procedimento-agenda-list/procedimento-agenda-list.component';
import { ProcedimentoAgendaMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/procedimento-agenda-maintenance/procedimento-agenda-maintenance.component';
import { CadastroTomadaComponent } from './com/copeagenda/view/procedimento/procedimento-agenda/tomadas/cadastro-tomada/cadastro-tomada.component';
import { ProcedimentoConsultaListComponent } from './com/copeagenda/view/procedimento/procedimento-consulta/procedimento-consulta-list/procedimento-consulta-list.component';
import { ProcedimentoConsultaMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-consulta/procedimento-consulta-maintenance/procedimento-consulta-maintenance.component';
import { ProcedimentoListComponent } from './com/copeagenda/view/procedimento/procedimento-list/procedimento-list.component';
import { ProcedimentoMaintenanceComponent } from './com/copeagenda/view/procedimento/procedimento-maintenance/procedimento-maintenance.component';
import { RelDisponibilidadeVagasConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-disponibilidade-vagas/rel-disponibilidade-vagas-consulta.component';
import { RelMarcacaoInternaConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-marcacao-interna/rel-marcacao-interna-consulta/rel-marcacao-interna-consulta.component';
import { RelMarcacaoConsultaComponent } from './com/copeagenda/view/relatorio/consulta/rel-marcacao/rel-marcacao-consulta/rel-marcacao-consulta.component';
import { RelDisponibilidadeVagasProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-disponibilidade-vagas/rel-disponibilidade-vagas-procedimento/rel-disponibilidade-vagas-procedimento.component';
import { RelMarcacaoInternaProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-marcacao-interna/rel-marcacao-interna-procedimento/rel-marcacao-interna-procedimento.component';
import { RelMarcacaoProcedimentoComponent } from './com/copeagenda/view/relatorio/procedimento/rel-marcacao/rel-marcacao-procedimento/rel-marcacao-procedimento.component';
import { UnidadesListComponent } from './com/copeagenda/view/unidades/unidades-list/unidades-list.component';
import { UsuarioListComponent } from './com/copeagenda/view/usuario/usuario-list/usuario-list.component';
import { UsuarioMaintenanceComponent } from './com/copeagenda/view/usuario/usuario-maintenance/usuario-maintenance.component';
import { RelMarcacaoInternaGlobalComponent } from './com/copeagenda/view/relatorio/global/rel-marcacao-interna/rel-marcacao-interna-global/rel-marcacao-interna-global.component';
import { SelecaoAgendamentoComponent } from './com/copeagenda/view/marcacao/selecao-agendamento/selecao-agendamento.component';

const routes: Routes = [
  { path: '', redirectTo: 'paginaInicial', pathMatch: 'full' },
  { path: 'paginaInicial', component: PaginaInicialComponent, data: { isPagInicial: true } },

  { path: 'unidades', component: UnidadesListComponent, data: { isPagInicial: false } },

  /*
    ##################################################
    ## AUTENTICACAO
    ##################################################
  */
  { path: 'login', component: LoginComponent, data: { isPagInicial: true } },

  /*
    ##################################################
    ## PACIENTES
    ##################################################
  */
  {
    path: 'pacientes', component: PacienteListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterPaciente', component: PacienteMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterPaciente/:id', component: PacienteMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'cadastrarDependente', component: CadastroDependentePeloAdminComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'dependentes', component: DependenteListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterDependente', component: DependenteMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'transferirDependenteParaTitular', component: TransferenciaTitularMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
  ##################################################
  ## ESPECIALIDADES
  ##################################################
*/
  {
    path: 'especialidades', component: EspecialidadeListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterEspecialidade', component: EspecialidadeMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterEspecialidade/:id', component: EspecialidadeMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## MEDICOS
    ##################################################
  */
  {
    path: 'medicos', component: MedicoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterMedico', component: MedicoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterMedico/:id', component: MedicoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## PROCEDIMENTO
    ##################################################
  */
  {
    path: 'procedimentos', component: ProcedimentoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterProcedimento', component: ProcedimentoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'cadastrarConflito', component: CadastroConflitoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'procedimentoAgenda', component: ProcedimentoAgendaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterProcedimentoAgenda', component: ProcedimentoAgendaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'cadastroTomada', component: CadastroTomadaComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
  ##################################################
  ## PROCEDIMENTO CONSULTA
  ##################################################
*/
  {
    path: 'procedimentoConsulta', component: ProcedimentoConsultaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterProcedimentoConsulta', component: ProcedimentoConsultaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterProcedimentoConsulta/:id', component: ProcedimentoConsultaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## FALTA MEDICA
    ##################################################
  */
  {
    path: 'faltaMedica', component: FaltaMedicaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFaltaMedica', component: FaltaMedicaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFaltaMedica/:id', component: FaltaMedicaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## AGENDA MEDICA
    ##################################################
  */
  {
    path: 'agendaMedica', component: AgendaMedicaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'manterAgendaMedicaHorarioIndividual', component: AgendaMedicaHorarioIndividualMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'manterAgendaMedica', component: AgendaMedicaMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
  ##################################################
  ## USUARIOS
  ##################################################
  */
  {
    path: 'usuarios', component: UsuarioListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterUsuario', component: UsuarioMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterUsuario/:id', component: UsuarioMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## FILIAIS
    ##################################################
  */
  {
    path: 'filiais', component: FilialListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFilial', component: FilialMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFilial/:id', component: FilialMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## PLANO DE SAUDE
    ##################################################
  */
  {
    path: 'planoSaude', component: PlanoSaudeListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterPlanoSaude', component: PlanoSaudeMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterPlanoSaude/:id', component: PlanoSaudeMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REDEFINICAO DE SENHA
    ##################################################
  */
  {
    path: 'redefinicaoSenha', component: RedefinirSenhaComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },


  /*
    ##################################################
    ## ASSOCIACOES
    ##################################################
  */

  // ## ASSOCIACAO FILIAL X MEDICO
  {
    path: 'associacaoFilialMedico', component: AssociacaoFilialMedicoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  // ## ASSOCIACAO FILIAL X ESPECIALIDADE
  {
    path: 'associacaoFilialEspecialidade', component: AssociacaoFilialEspecialidadeComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  // ## ASSOCIACAO MEDICO X PLANO SAUDE
  {
    path: 'associacaoMedicoPlanoSaude', component: AssociacaoMedicoPlanoSaudeComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  // ## ASSOCIACAO PLANO SAUDE X POCEDIMENTO
  {
    path: 'associacaoPlanoSaudeProcedimento', component: AssociacaoPlanoSaudeProcedimentoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## FERIADOS
    ##################################################
  */
  {
    path: 'feriados', component: FeriadoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFeriado', component: FeriadoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterFeriado/:id', component: FeriadoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## MOTIVO CANCELAMENTO
    ##################################################
  */
  {
    path: 'motivoCancelamento', component: MotivoCancelamentoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterMotivoCancelamento', component: MotivoCancelamentoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'manterMotivoCancelamento/:id', component: MotivoCancelamentoMaintenanceComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## MOTIVO CANCELAMENTO
    ##################################################
  */
  {
    path: 'historicoEventosSistema', component: HistoricoEventoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE DISPONIBILIDADE DE VAGAS PARA CONSULTA
    ##################################################
  */
  {
    path: 'relDisponibilidadeDeVagasParaConsulta', component: RelDisponibilidadeVagasConsultaComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE MARCACOES INTERNAS PARA CONSULTA
    ##################################################
  */
  {
    path: 'relMarcacoesInternasParaConsulta', component: RelMarcacaoInternaConsultaComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE MARCACOES DE CONSULTA
    ##################################################
  */
  {
    path: 'relMarcacoesConsultas', component: RelMarcacaoConsultaComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE DISPONIBILIDADE DE VAGAS PARA EXAME
    ##################################################
  */
  {
    path: 'relDisponibilidadeDeVagasParaExame', component: RelDisponibilidadeVagasProcedimentoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE MARCACOES INTERNAS PARA EXAME
    ##################################################
  */
  {
    path: 'relMarcacoesInternasParaExame', component: RelMarcacaoInternaProcedimentoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE MARCACOES DE EXAME
    ##################################################
  */
  {
    path: 'relMarcacoesExames', component: RelMarcacaoProcedimentoComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## REL. DE MARCACOES INTERNAS PARA EXAME
    ##################################################
  */
    {
      path: 'relMarcacoesInternasGlobal', component: RelMarcacaoInternaGlobalComponent,
      data: {
        isPagInicial: false,
        authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
      },
      canActivate: [AuthGuard]
    },
  
  /*
    ##################################################
    ## NOTIFICACOES DE CANCELAMENTO
    ##################################################
  */
  {
    path: 'notificacoesCancelamento', component: NotificacaoCancelamentoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'detalharLoteNotificacaoSms', component: NotificacaoCancelamentoDetailComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'criarLoteNotificacaoSms', component: NotificacaoCancelamentoCreateComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'envioComprovante', component: EnvioComprovanteListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'reenvioComprovanteProcurarPaciente', component: ProcurarPacienteComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'reenvioComprovanteConsultaProcurarPaciente', component: ProcurarPacienteComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'reenvioComprovanteProcedimentoProcurarPaciente', component: ProcurarPacienteComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'selecionarMarcacaoConsultaParaReenvioDeComprovante', component: SelecionarMarcacaoConsultaParaReenvioComprovanteComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'selecionarMarcacaoProcedimentoParaReenvioComprovante', component: SelecionarMarcacaoProcedimentoParaReenvioComprovanteComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## ATENDIMENTO CONSULTA
    ##################################################
  */
  {
    path: 'atendimentoConsulta', component: AtendimentoConsultaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'localizaAtendimentoConsulta', component: LocalizarAtendimentoConsultaListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'localizaAtendimentoProcedimento', component: LocalizarAtendimentoProcedimentoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'informacaoFechamento', component: InformacaoFechamentoDetailComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'cancelarMarcacao', component: InformacaoCancelamentoCreateComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'informacaoCancelamento', component: InformacaoCancelamentoDetailComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'detalharMarcacaoConsulta', component: AtendimentoConsultaDetailComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'detalharMarcacaoProcedimento', component: AtendimentoProcedimentoDetailComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

  /*
    ##################################################
    ## ATENDIMENTO PROCEDIMENTO
    ##################################################
  */
  {
    path: 'atendimentoProcedimento', component: AtendimentoProcedimentoListComponent,
    data: {
      isPagInicial: false,
      authorities: ['ROLE_USUARIO', 'ROLE_ADMIN_ATENDIMENTO', 'ROLE_ADMIN', 'ROLE_ROOT']
    },
    canActivate: [AuthGuard]
  },

/*
##################################################
## MARCACAO DE CONSULTAS E EXAMES
##################################################
*/
  {
    path: 'marcacaoConsulta', component: MarcacaoConsultaComponent, data: { isPagInicial: false },
    children: [
      { path: '', redirectTo: 'cadastrarPaciente', pathMatch: 'full' },
      { path: 'cadastrarPaciente', component: CadastroPacienteComponent, data: { isPagInicial: false } },
      { path: 'cadastrarDependente', component: CadastroDependenteComponent, data: { isPagInicial: false } },
      { path: 'agendamentosPaciente', component: AgendamentoPacienteListComponent, data: { isPagInicial: false } },

      { path: 'selecionarPaciente', component: SelecaoPacienteComponent, data: { isPagInicial: false } },
      { path: 'selecionarConsulta', component: SelecaoConsultaComponent, data: { isPagInicial: false } },

      { path: 'marcacaoConsultaRealizada', component: MarcacaoConsultaRealizadaComponent, data: { isPagInicial: false } },
      { path: 'enviarComprovantePorEmail', component: EnviarComprovanteEmailComponent, data: { isPagInicial: false } },
      { path: 'enviarComprovantePorSMS', component: EnviarComprovanteSmsComponent, data: { isPagInicial: false } },

      { path: 'selecionarExame', component: SelecaoProcedimentoComponent, data: { isPagInicial: false } },
      { path: 'selecionarAgendamento', component: SelecaoAgendamentoComponent, data: { isPagInicial: false } },
      { path: 'marcacaoProcedimentoRealizado', component: MarcacaoProcedimentoRealizadoComponent, data: { isPagInicial: false } },
    ]
  },

  /*
  ##################################################
  ## MARCACAO DE CONSULTAS E EXAMES (Acesso Direto)
  ##################################################
  */
  {
    path: 'consultas', component: CadastroPacienteComponent, data: { isPagInicial: false, tipoMarcacao: TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA },
  },

  {
    path: 'exames', component: CadastroPacienteComponent, data: { isPagInicial: false, tipoMarcacao: TipoMarcacaoEnum.TIPO_MARCACAO_EXAME },
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
